import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityImport } from '../../projectDetailsActivities.models';

export const ImportActivity = ({ values }: IProjectActivity<IProjectActivityImport>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {values.wasAnnotationsImported ? t('activity_description_Import_with_Annotation') : t('activity_description_Import')}
      {values.fileName ? (
        <>
          {t('activity_description_Import_from_file')}
          <b>{values.fileName}</b>
        </>
      ) : (
        ''
      )}
      .
    </span>
  );
};
